module.exports = __webpack_public_path__ + "static/media/r-md12.167e359e.png";